<template>
  <div class="categoryName-v">
    医疗机构药店
  </div>
</template>
<script>
export default{
  props:['categoryName']
}
</script>
<style lang="scss">
.categoryName-v{
  line-height: 60px;
  color:#67ebc3;
  font-size: 60px;
  font-weight: 700;
  letter-spacing: 10px;
  // text-align: center;
  position: relative;
  top: 42px;
  right: -30px;
  // writing-mode: tb-rl;
}
</style>




// WEBPACK FOOTER //
// src/components/categoryName/hospital.vue